import EventEmitter from 'eventemitter3';

class CustomEventEmitter extends EventEmitter {
  emit(event, ...args) {
    if (!event) {
      throw new Error('Tried to emit undefined event');
    }

    super.emit(event, ...args);
  }
}

export default new CustomEventEmitter();
